<template>
  <div class="component-content configuration-groupset">
    <div class="component-content-scroll">
      <div class="component-content-title mb-3">Select your bars</div>

      <option-list
        :options="handlebarsInput"
        :target="this.results.handlebars"
        :inputName="'handlebars'"
        :measures="measures"
        :measureLabel="'Set handlebar length'"
        :targetMeasure="this.measures.handlebars"
        :results="results"
        v-on:target-updated="updateHandlebars"
        v-on:update-measures="setMeasure"
        v-if="this.components.handlebars"
      ></option-list>

      <div
        class="color-selector mt-4 pt-2"
        v-if="showColorSelector()"
      >
        <ColorSelector
          :primaryColor="results.colour.primaryColor"
          :secondaryColor="results.colour.secondaryColor"
          :colors="colors"
          :componentId="this.results.handlebars.id"
          :componentType="'handlebars'"
          :results="results"
          v-on:component-color-selected="selectColor"
        ></ColorSelector>
      </div>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import ColorSelector from "../../shared/component-color-selector.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-groupset",
  data() {
    return {};
  },
  components: {
    OptionList,
    ColorSelector,
  },
  props: [
    "configuratorSteps",
    "currentStep",
    "results",
    "components",
    "measures",
    "colors",
    "bike",
  ],
  methods: {
    goNext: function () {
      if (this.results.handlebars == null) {
        this.$emit("set-error", "Please select a handlebar");
        return false;
      }

      if (
        this.results.handlebars != null &&
        this.results.handlebars.id != -1 &&
        this.results.handlebars.measure == null
      ) {
        this.$emit("set-error", "Please select a handlebar measure");
        return false;
      }

      if (
        this.results.handlebars != null &&
        this.results.handlebars.id != -1 &&
        this.showColorSelector() &&
        typeof this.results.handlebars.colour == 'undefined'
      ) {
        this.$emit("set-error", "Please select a handlebar colour");
        return false;
      }
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    selectColor: function (color, componentId, componentType) {
      this.$emit("component-color-selected", color, componentId, componentType);
    },
    updateHandlebars: function (e) {
      this.handlebarsInput = e;
    },
    updateBartape: function (e) {
      this.bartapeInput = e;
    },
    setMeasure: function (measure) {
      this.measuresInput = measure;
    },
    getMeasure: function () {
      if (this.results.handlebars != null) {
        return this.results.handlebars.measure;
      }
      return null;
    },
    showColorSelector: function () {
      if (
        typeof this.results.handlebars != "undefined" &&
        this.results.handlebars != null &&
        this.results.handlebars.is_paintable == 1 &&
        this.results.colour.primaryColor != null &&
        //this.results.colour.secondaryColor != null &&
        //this.results.stem.id != 14 &&
        this.results.handlebars.id != -1 &&
        this.bike.id != 32
      ) {
        //console.log(['this.results.stem != "undefined"','this.results.stem != null','this.results.stem.is_paintable == 1','this.results.stem.measure != undefined','this.results.colour.primaryColor != null,this.results.stem.id != -1']);
        //console.log([this.results.stem != "undefined",this.results.stem != null,this.results.stem.is_paintable == 1,this.results.stem.measure != "undefined",this.results.colour.primaryColor != null,this.results.stem.id != -1])
        return true;
      }
      return false;
    },
    canFinishConfiguration: function() {
        // if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0)
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    handlebarsInput: {
      get: function () {
        var handlebarsList;
        if (this.results.fork != null){
          if (this.results.fork.is_electronic == true){
            handlebarsList = this.components.handlebars[0].filter((item) => { return item.is_electronic == 1 });
          } else {
            handlebarsList = this.components.handlebars[0].filter((item) => { return item.is_electronic != 1 });
          }
        } else {
          handlebarsList = this.components.handlebars[0];
        }
        return handlebarsList;
      },
      set: function (e) {
        this.$emit("set-handlebars", e);
      },
    },
    measuresInput: {
      get: function () {
        if (
          this.results.handlebars == null ||
          typeof this.results.handlebars.measure == "undefined"
        ) {
          return null;
        }
        return this.results.handlebars.measure;
      },
      set: function (e) {
        this.$emit("set-measure", "handlebars", e);
      },
    },
    bartapeInput: {
      get: function () {
        return this.components.bartape[0];
      },
      set: function (e) {
        this.$emit("set-bartape", e);
      },
    },
    integratedInput: {
      get: function () {
        return this.components.integratedhandlebar[0];
      },
      set: function (e) {
        this.$emit("set-handlebars", e);
      },
    },
  },
  created() {
    let tabs = document.querySelectorAll(".nav-tabs .nav-item");
    this.currentInternalStep = 0;
    this.totalInternalTabs = tabs.length;
  },
};
</script>

<style lang="scss" scoped>
.configuration-groupset {
}
</style>

